import * as Sentry from "@sentry/vue";

export function initializeSentry(Vue) {
    Sentry.init({
        Vue,
        dsn: "https://7b65d8fee0b85a03c7a12384ccb1dfbe@sentry.digix.com.br/27",
        environment: process.env.NODE_ENV,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        tracePropagationTargets: ["**"]
    });
}